import { useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { Panel, Empty, fmtDate, apiError } from "@/admin/ui";

export default function NotesTab({ s, onChange }) {
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);
  const add = async () => {
    setSaving(true);
    try {
      const { data } = await api.post(`/admin/students/${s.id}/notes`, { text });
      onChange([data, ...s.notes]); setText(""); toast.success("Nota guardada.");
    } catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };
  const remove = async (id) => {
    try { await api.delete(`/admin/students/${s.id}/notes/${id}`); onChange(s.notes.filter((n) => n.id !== id)); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <Panel title="Notas internas" action={<span className="adm-sub">Solo las ve el equipo</span>} testid="admin-student-notes">
      <textarea className="adm-textarea" value={text} onChange={(e) => setText(e.target.value)} maxLength={2000} placeholder="Escribe una nota sobre este alumno" data-testid="admin-note-input" />
      <div className="adm-row" style={{ justifyContent: "flex-end", margin: ".6rem 0 1rem" }}>
        <button className="adm-btn primary" onClick={add} disabled={saving || !text.trim()} data-testid="admin-note-save">{saving ? "Guardando..." : "Guardar nota"}</button>
      </div>
      {!s.notes.length ? <Empty text="Todavía no hay notas." testid="admin-notes-empty" /> : s.notes.map((n) => (
        <div key={n.id} className="adm-list-item" style={{ alignItems: "flex-start" }} data-testid={`admin-note-${n.id}`}>
          <div><p style={{ margin: 0, whiteSpace: "pre-wrap" }}>{n.text}</p><span className="adm-sub">{n.author} · {fmtDate(n.created_at, true)}</span></div>
          <button className="adm-btn sm danger" onClick={() => remove(n.id)} aria-label="Eliminar nota" data-testid={`admin-note-delete-${n.id}`}><Trash2 size={14} /></button>
        </div>
      ))}
    </Panel>
  );
}
